import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../images/Logo.png';
import Briefcase from '../elements/Portfolio';
import Footer from '../elements/Footer';
import Caja from '../styles/components/box.styles';
import { Espacio, Portfolio } from '../styles/components/portfolio-page.styles';

const PortafolioPage = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Portfolio>
            <Helmet>
                <link rel="shortcut icon" href={ favicon } type="image/x-icon" data-react-helmet="true"/>
            </Helmet>
            <Caja>
                <Espacio>
                    <Briefcase/>
                </Espacio>
                <Footer/>
            </Caja>
        </Portfolio>
    );
}
 
export default PortafolioPage;